import styled from 'styled-components';

export const MainGamificationSectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: var(--colors-surface-primary, #fff);
    border-radius: 8px;
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    padding: 24px;
`;

export const GamificationSectionWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;
